let toggler = document.getElementById('navbar-toggler');
let closer = document.getElementById('navbar-closer');

toggler.addEventListener('click', () => {
    document.getElementById('navbar').classList.add('show');
});
closer.addEventListener('click', () => {
    document.getElementById('navbar').classList.remove('show');
});